import { render, staticRenderFns } from "./TaskConfig.vue?vue&type=template&id=5ef9fa4c&scoped=true"
import script from "./TaskConfig.vue?vue&type=script&lang=js"
export * from "./TaskConfig.vue?vue&type=script&lang=js"
import style0 from "./TaskConfig.vue?vue&type=style&index=0&id=5ef9fa4c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef9fa4c",
  null
  
)

export default component.exports